import { action, observable, makeObservable } from 'mobx';
import {contentLoaders, SuccessResponse, X3Level, X3LevelUpdateModel} from '../../../../domain';
import {HttpPromiseState, SaveStateHolder, StringControl, validators} from '../../../../lib/helpers';

export class EditLevelStore implements SaveStateHolder {
  name: StringControl;

  @observable.ref
  save: HttpPromiseState<SuccessResponse> | null;

  constructor(readonly level: X3Level) {
    makeObservable(this);
    this.name = new StringControl('name', level.Name, validators.required);
    this.save = null;
  }

  @action
  complete() {
    if (this.save?.isPending === true)
      return;
    this.name.markTouched();
    if (this.name.invalid)
      return;

    const model: X3LevelUpdateModel = {
      AgeCategoryId: this.level.AgeCategoryId,
      Index: this.level.Index,
      Name: this.name.value
    };
    this.save = contentLoaders.x3level.update(this.level.Id, model);
  }
}
